import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import MenuModel from '../model/menu/menuModel';

@Injectable({
  providedIn: 'root'
})
export class GlobalesService {

  //#region Propiedades

  public version: string = "2.2.1"
  public redirectUrl: string
  public mostrarCodigo = new BehaviorSubject<boolean>(false)
  public backupConfigurado = new BehaviorSubject<number>(-1)

  //#endregion

  //#region Constructor

  constructor(
  ) { }

  //#endregion

  //#region Online

  public onlineObservable = new Observable()

  //#endregion

  //#region Estado aplicación

  public estadoAplicacion = new BehaviorSubject<'Actualizada' | 'Descargando' | 'ActualizacionPendiente' | 'NoServiceWorker'>(null)

  //#endregion

}
